import React from 'react';
import { motion } from 'framer-motion';
import { PAGE_TRANSITION_DURATION_MS } from '../utils/pageTransition';

interface PageTransitionProps {
  children: React.ReactNode;
}

const durationSeconds = PAGE_TRANSITION_DURATION_MS / 1000;

const pageVariants = {
  initial: {
    opacity: 0,
  },
  animate: {
    opacity: 1,
    transition: {
      duration: durationSeconds,
      ease: [0.4, 0, 0.2, 1] as const,
    },
  },
  exit: {
    opacity: 0,
    transition: {
      duration: durationSeconds,
      ease: [0.4, 0, 0.2, 1] as const,
    },
  },
};

const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  return (
    <motion.div
      initial="initial"
      animate="animate"
      exit="exit"
      variants={pageVariants}
      style={{
        width: '100%',
        willChange: 'transform',
      }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
